import s from '../../styles/components/menu/MenuHeader.module.css';

export default function MenuHeader({ label, title, menus, menuId, menu, onMenuChange }) {
  return (
    <div className={s.head}>
      {label && <span className={s.label}>{label}</span>}
      {title && <h2 className={s.title}>{title}</h2>}
      <div className={s.controls}>
        {menus.length > 1 && (
          <div className={s.selectWrap}>
            <select
              value={menuId}
              onChange={(e) => onMenuChange(e.target.value)}
              aria-label="Choose a menu"
              className={s.select}
            >
              {menus.map((m) => (
                <option key={m.id} value={m.id}>{m.name}</option>
              ))}
            </select>
            <span className={s.caret} aria-hidden="true">▼</span>
          </div>
        )}
        {menu.note && <p className={s.note}>{menu.note}</p>}
      </div>
    </div>
  );
}